export default __webpack_public_path__ + "static/media/knarin.d9ec04b8.svg";